<template>
    <div class="container">
        <field-wrapper floating :label-text="texts.from_label">
            <template v-slot:toggle>
                <span v-if="fromDate">{{ fromDate | momentDate }}</span>
                <span v-else>{{ texts.from_placeholder }}</span>
            </template>

            <template v-slot:default>
                <date-picker
                    v-model="fromDate"
                    :open-date="disabledFromDates.to"
                    :disabled-dates="disabledFromDates"
                />
            </template>
        </field-wrapper>

        <field-wrapper
            :class="{ disabled: !fromDate }"
            floating
            :label-text="texts.to_label"
        >
            <template v-if="fromDate" v-slot:toggle>
                <span v-if="toDate">{{ toDate | momentDate }}</span>
                <span v-else>{{ texts.to_placeholder }}</span>
            </template>

            <template v-slot:default>
                <span v-if="!fromDate">{{ texts.to_placeholder }}</span>
                <date-picker
                    v-if="fromDate"
                    v-model="toDate"
                    :use-utc="false"
                    :disabled-dates="disabledToDates"
                />
            </template>
        </field-wrapper>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FieldWrapper from "@/components/elements/FieldWrapper";
import DatePicker from "@/components/elements/DatePicker";
import moment from "moment";

export default {
    components: {
        FieldWrapper,
        DatePicker
    },
    props: {},
    computed: {
        texts() {
            return this.$t("field_retiree_date_range");
        },
        fromDate: {
            get() {
                const val = this.$store.getters[
                    "products/retireeticket/getValidFrom"
                ];

                return val ? moment.utc(val).toDate() : val;
            },
            set(newValue) {
                this.$store.commit(
                    "products/retireeticket/updateValidFrom",
                    newValue
                );

                const newToValue = moment(newValue)
                    .add(this.product.validitySpan.minimum - 1, "days")
                    .toDate();

                this.$store.commit(
                    "products/retireeticket/updateValidTo",
                    newToValue
                );
            }
        },
        toDate: {
            get() {
                const val = this.$store.getters[
                    "products/retireeticket/getValidTo"
                ];

                return val ? moment.utc(val).toDate() : val;
            },
            set(newValue) {
                this.$store.commit(
                    "products/retireeticket/updateValidTo",
                    newValue
                );
            }
        },
        disabledFromDates() {
            return {
                to: moment()
                    .startOf("day")
                    .add(this.shipmentDays, "days")
                    .toDate()
            };
        },
        disabledToDates() {
            if (!this.fromDate) {
                return {
                    days: [0, 1, 2, 3, 4, 5, 6]
                };
            }

            return {
                to: moment(this.fromDate)
                    .startOf("day")
                    .add(this.product.validitySpan.minimum - 1, "days")
                    .toDate(),
                from: moment(this.fromDate)
                    .startOf("day")
                    .add(this.product.validitySpan.maximum - 1, "days")
                    .toDate()
            };
        },
        ...mapGetters({
            product: "products/retireeticket/getSelectedProductVariant",
            shipmentDays: "system/snailmailShipmentDelayDayCount"
        })
    },
    methods: {
        ...mapActions({})
    }
};
</script>

<style scoped lang="scss">
.container {
    > *:first-child {
        margin-bottom: 1rem;
    }

    .disabled {
        cursor: not-allowed !important;
        opacity: 0.7;
    }

    @media (min-width: $breakpoint-tablet) {
        display: flex;

        > *:first-child {
            margin-right: $layout-gap / 2;
            margin-bottom: 0;
        }

        > * {
            flex: 1 1 0;
        }
    }
}
</style>
